










































































































































































































import Application from '@/datatypes/application';
import ApplicationService from '@/services/application/application-service';
import Vue from 'vue';
import camelcase from 'camelcase';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default Vue.extend({
  data: () => ({
    application: new Application({}),
    applicationService: new ApplicationService(),
    errorMessage: '',
    nextPointer: undefined as undefined | string,
    isApproving: false,
    isDisabling: false,
    isEnabling: false,
    isRejecting: false,
    rejectionReason: '',
  }),

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  methods: {
    routeChanged() {
      this.getApplication();
    },

    scopeTranslationName(scope) {
      return `fields.application.scope.${camelcase(scope)}`;
    },

    getApplication() {
      const applicationId = this.$route.params.id;

      this.applicationService.show(applicationId).then((response) => {
        this.application = new Application(camelcaseKeysDeep(response.data));
      }).catch((error) => {
        this.notFound(error, this.$router, '/applications');
      });
    },

    confirmApproval() {
      this.applicationService.approve(this.$route.params.id).then((response) => {
        this.$snackbar.message(this.$i18n.t('messages.application.applicationApproved'));

        this.application = new Application(camelcaseKeysDeep(response.data));
      }).catch((error) => {
        this.$snackbar.message(error.response.data.message);
      });
    },

    confirmDisabling() {
      this.applicationService.disable(this.$route.params.id).then((response) => {
        this.$snackbar.message(this.$i18n.t('messages.application.applicationDisabled'));

        this.application = new Application(camelcaseKeysDeep(response.data));
      }).catch((error) => {
        this.$snackbar.message(error.response.data.message);
      });
    },

    confirmEnabling() {
      this.applicationService.enable(this.$route.params.id).then((response) => {
        this.$snackbar.message(this.$i18n.t('messages.application.applicationEnabled'));

        this.application = new Application(camelcaseKeysDeep(response.data));
      }).catch((error) => {
        this.$snackbar.message(error.response.data.message);
      });
    },

    notFound(error, router, location): void {
      if (error.response.status === 404) {
        this.$router.push(location, () => {
          this.$store.commit('errorMessage', 'Not found.');
        });
      }
    },

    rejectApplication(): void {
      this.applicationService.reject(this.$route.params.id, { reason: this.rejectionReason }).then(
        (response) => {
          this.$snackbar.message(this.$i18n.t('messages.application.applicationRejected'));

          this.application = new Application(camelcaseKeysDeep(response.data));
          this.isRejecting = false;
        },
      ).catch((error) => {
        this.$snackbar.message(error.response.data.message);
      });
    },
  },
  computed: {
    canApprove(): boolean {
      return this.application.status === 'pending_approval';
    },

    canDisable(): boolean {
      return this.application.status === 'approved';
    },

    canReject(): boolean {
      return this.application.status === 'pending_approval';
    },

    canEnable(): boolean {
      return (this.application.status === 'disabled');
    },
  },
});
